import '../App.css';
import React from 'react';
// import Footer from '../Component/Footer';
import { FaHome } from '@react-icons/all-files/fa/FaHome';
import { GrFormClose } from '@react-icons/all-files/gr/GrFormClose';
import { Form, Button } from 'react-bootstrap';
// import Modal from 'react-bootstrap/Modal';
import Header from '../Component/Header';
// import { isMobile } from 'react-device-detect';
import {  Alert } from 'react-bootstrap';
import {ReturnBetValidation} from '../static/ReturnBetValidation';
import { CreateBetOrder, verifyUserOrderIDStatus, getUserKeyIn, getMyselfF, searchDownlineHR } from '../Api';
import Moment from 'moment-timezone';
import { connect } from 'react-redux';
import { language } from '../language';
import Loading3 from '../Images/loading-3.gif';
import SearchUsersModal from '../Component/Modal/SearchUsersModal';
import i59GameRelations from '../static/i59RelationToI82.json';
import { findPermutations } from '../utility/Permutation';

// import Select from 'react-select';
var timer
var rechecktimer
// import { language } from '../language';
// import { findPermutations } from '../utility/Permutation'
// import { isCompositeComponent } from 'react-dom/test-utils';
// import Dropzone from 'react-dropzone';

class CSVFileConvert extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: this.props.username,
      token: this.props.token,
      TodayDate: Moment(new Date()).format('DD/MM/YYYY (ddd)'),
      FileName: '',
      FileResultWord: '',
      FinalResult: "D#\n",
      hightlight: false,
      disabled: false,
      showNotification: false,
      notificationMessage: '',
      notificationType: 'success',
      SelectedUser: '',
      optionsUsername: '',
      getUsers: [],
      userID: this.props.userID,
      loading: false,
      ShowReceipt: false,
      ReceiptDisplay: '',
      Balance: 0,
      SearchUSersModal: false,
      SearchedID : [],
      SearchUser: '',

      // files: [],
      // Base64: '',
      KeyIn1: [],
      KeyIn2: [],
      JinNan : false,
    }
    this.UploadFiletxt = this.UploadFiletxt.bind(this);
    this.ConfirmSaveBet = this.ConfirmSaveBet.bind(this);
    this.CleanData = this.CleanData.bind(this);
    this.fileInputRef = React.createRef();

    this.openFileDialog = this.openFileDialog.bind(this);
    this.onDragOver = this.onDragOver.bind(this);
    this.onDragLeave = this.onDragLeave.bind(this);
    this.onDrop = this.onDrop.bind(this);
    this.SelectedUser = this.SelectedUser.bind(this);
    this.handleCloseSearchModal = this.handleCloseSearchModal.bind(this);
  }

  async componentDidMount(){
    const UserAuthorities = JSON.parse(this.props.UserAuthority)
    this.setState({ userID: (UserAuthorities.isSub === 1) ? UserAuthorities.ActingAs : this.props.userID}, () => {
      if ((UserAuthorities && UserAuthorities.Bet) === 0) {
        window.location.href='/Home'; 
      }
      this.getDownline();
    })
  }

  async componentDidUpdate(prevProps, prevState){
    const previousFileResult = JSON.parse(JSON.stringify(prevState.FileResultWord));
    const latestFileResult = JSON.parse(JSON.stringify(this.state.FileResultWord));
    // console.log('previousFileResult', previousFileResult);
    // console.log('latestFileResult',latestFileResult);

    if(previousFileResult !== latestFileResult){
      //To Do. verify if keyin is provided, if not, return error.
      let organizedLineObject = {};
      const linesOfFiles = latestFileResult.split('\n');

      for(const [index, line] of Object.entries(linesOfFiles)){
        // console.log('Currently processing line index : ', index , ". line ", line);
        // continue if line is blank
        if(line === ""){
          continue;
        }
        const lineArr = line.split(',');
        if(line.includes(';') && line.split(';').length === 2){
          // continue if line is not word line.
          continue;
        }
        if(lineArr.length !== 4 ){
          // if word line format is invalid.
          console.error('Invalid line format 1 at line : ',index + 1 , " ", line);
          return;
        }

        // line check illegal character
        if(/[a-zA-Z!@$%^&()_‘+=\]{};':"\\|<>?]+/.test(line)){
          // console.log('line error',line);
          this.openNotification(`FormatError`);
          this.setState({ notificationType: 'error'});
          this.CleanData();
          return;
        }
        // line check language other than invalid language
        if (/[\u3400-\u9FBF]+/.test(line)) {
          this.openNotification('NotAllowChinese')
          this.setState({ notificationType: 'error'});
          this.CleanData();
        }
        
        // organize based on game, 
        const [gameId, i59gameRelationId, betNumber, amount] = lineArr;
        // console.log('Line details : ', gameId, " ", i59gameRelationId, " ", betNumber, " ", amount);
        if(!organizedLineObject[`G${gameId}`]) {
          organizedLineObject[`G${gameId}`] = {};
        }

        // determine i59 game relationId and amount.
        const i59GameRelation =i59GameRelations[i59gameRelationId];
        if(!i59GameRelation){
          this.openNotification('InvalidGameRelation');
          this.setState({ notificationType: 'error'});
          return;
        }

        // ibox and not ibox.
        if(i59GameRelation['isIbox']){
          // this line is ibox, number and amount needed to be splitted.
          const permutationOfBetNum = findPermutations(betNumber);
          for(const eachPermuBetNum of permutationOfBetNum) {
            if(!organizedLineObject[`G${gameId}`][`${eachPermuBetNum}`]){
              organizedLineObject[`G${gameId}`][`${eachPermuBetNum}`] = {};
            }
            const amountEachBetNumber = (Number(amount) / (permutationOfBetNum.length)).toFixed(2);

            if(!organizedLineObject[`G${gameId}`][`${eachPermuBetNum}`][`${i59GameRelation['betMode']}`]){
              organizedLineObject[`G${gameId}`][`${eachPermuBetNum}`][`${i59GameRelation['betMode']}`] = Number(0);
            }

            const thisAmount = Number(organizedLineObject[`G${gameId}`][`${eachPermuBetNum}`][`${i59GameRelation['betMode']}`]) + Number(amountEachBetNumber);
            
            organizedLineObject[`G${gameId}`][`${eachPermuBetNum}`][`${i59GameRelation['betMode']}`] = thisAmount.toFixed(2);
          }
        } else {
          // not ibox, no processing on words and amount needed.
          if(!organizedLineObject[`G${gameId}`][`${betNumber}`]){
            organizedLineObject[`G${gameId}`][`${betNumber}`] = {};
          }

          if(!organizedLineObject[`G${gameId}`][`${betNumber}`][`${i59GameRelation['betMode']}`]){
            organizedLineObject[`G${gameId}`][`${betNumber}`][`${i59GameRelation['betMode']}`] = 0;
          }

          const thisAmount = Number(organizedLineObject[`G${gameId}`][`${betNumber}`][`${i59GameRelation['betMode']}`]) + Number(amount);
          organizedLineObject[`G${gameId}`][`${betNumber}`][`${i59GameRelation['betMode']}`] = thisAmount.toFixed(2);
        }
      }

      // console.log('organizedLineObject', organizedLineObject);
      let betTextInI82 = "D#\n";
      for(const [gameId, betNumberAmountsObj] of Object.entries(organizedLineObject)) {
        if(this.state.JinNan === null){
          this.openNotification(`InvalidAcc`);
          this.setState({ notificationType: 'error'});
          return;
        }
        betTextInI82 += `${this.state.JinNan ? '#' : ''}${gameId.substring(1)}\n`;
        
        for(const [bettingNumber, amountsObj] of Object.entries(betNumberAmountsObj)) {
          let keyin1TextObj = {};
          let keyin2TextObj = {};
          let keyin1Text = '';
          let keyin2Text = '';

          // check 5D,6D
          if(bettingNumber.length === 5 || bettingNumber.length === 6) {
            if(gameId !== 'G3'){
              this.openNotification(`FormatError`);
              this.setState({ notificationType: 'error'});
              return;
            }
            
            for(const [betMode, betAmt] of Object.entries(amountsObj)) {
              if(betMode !== '5D' && betMode !== '6D') {
                this.openNotification(`FormatError`);
                this.setState({ notificationType: 'error'});
                return;
              }

              betTextInI82 += `${bettingNumber}#${betAmt}\n`;
            }
            
            continue;
          }

          // determine the amount line. exp: #1###2
          for(const [bettingMode, bettingAmount] of Object.entries(amountsObj)) {
            // bettingMode at i82 backend is CA,CF. Old server and i82 fronend is A,C. 
            let _bettingMode = bettingMode;
            switch(bettingMode){
            case "CA":
              _bettingMode = "A";
              break;
            
            case "CF":
              _bettingMode = "C";
              break;

            default: 
              break;
            }

            if(this.state.KeyIn1.includes(_bettingMode)) {
              if(bettingNumber.length === 3){
                // determine which thousand betmode come first. ['A','C'] / ['C','A']
                let thousandWordKeyinMode = [];
                const betModeAInKeyin1 = this.state.KeyIn1.indexOf('A');
                const betModeCInKeyin1 = this.state.KeyIn1.indexOf('C');

                if(betModeAInKeyin1 > betModeCInKeyin1){
                  thousandWordKeyinMode = ['A','C'];
                } else {
                  thousandWordKeyinMode = ['C','A'];
                }
                const betModeIdxInKeyIn = thousandWordKeyinMode.indexOf(_bettingMode);
                
                keyin1TextObj[betModeIdxInKeyIn] = bettingAmount;

              } else if(bettingNumber.length === 4){
                const betModeIdxInKeyIn1 = this.state.KeyIn1.indexOf(_bettingMode);
                keyin1TextObj[(betModeIdxInKeyIn1)] = bettingAmount;
              } else {
                this.openNotification(`InvalidBetNumberLengthKeyin1`);
                this.setState({ notificationType: 'error'});
                return;
              }
            }else if(this.state.KeyIn2.includes(_bettingMode)) {
              if(bettingNumber.length === 3){
                // if number is thousand, keyinmode is fixed, as below.
                const thousandWordKeyinModeDefault = ['A', 'CB', 'CC', 'CD', 'CE', 'C'];
                const betModeIdxInKeyIn = thousandWordKeyinModeDefault.indexOf(_bettingMode);
                
                keyin2TextObj[betModeIdxInKeyIn] = bettingAmount;

              } else if(bettingNumber.length === 4){
                const betModeIdxInKeyIn2 = this.state.KeyIn2.indexOf(_bettingMode);
                keyin2TextObj[(betModeIdxInKeyIn2)] = bettingAmount;
              } else {
                this.openNotification(`InvalidBetNumberLengthKeyin2`);
                this.setState({ notificationType: 'error'});
                return;
              }
            }
          }

          if(Object.keys(keyin1TextObj).length > 0){
            const maxIdxInKeyIn1 = Object.keys(keyin1TextObj).reduce((prevMaxIdx, currentIdx) => prevMaxIdx > currentIdx ? prevMaxIdx : currentIdx);
            keyin1Text += `${bettingNumber}`;
            for(let i = 0; i <= maxIdxInKeyIn1; i++){
              if(!keyin1TextObj[i]){
                keyin1Text += `#`;
              } else if(!isNaN(keyin1TextObj[i])) {
                keyin1Text += `#${keyin1TextObj[i]}`
              } else {
                this.openNotification(`InvalidAmount`);
                this.setState({ notificationType: 'error'});
                return;
              }
            }

            betTextInI82 += `${keyin1Text}\n`;
          }

          if(Object.keys(keyin2TextObj).length > 0){
            const maxIdxInKeyIn2 = Object.keys(keyin2TextObj).reduce((prevMaxIdx, currentIdx) => prevMaxIdx > currentIdx ? prevMaxIdx : currentIdx);
            keyin2Text += `${bettingNumber}**`;
            for(let i = 0; i <= maxIdxInKeyIn2; i++){
              if(!keyin2TextObj[i]){
                keyin2Text += `#`;
              } else if(!isNaN(keyin2TextObj[i])) {
                keyin2Text += `#${keyin2TextObj[i]}`
              } else {
                this.openNotification(`InvalidAmount`);
                this.setState({ notificationType: 'error'});
                return;
              }
            }

            betTextInI82 += `${keyin2Text}\n`
          }
        }
      }
      // console.log('text 82',betTextInI82);
      this.setState({
        FinalResult: betTextInI82
      });
    } else {
      // console.log('File result are same');
    }
  }

  async getDownline() {
    const Username = this.props.username;
    const token = this.props.token

    // const DownlineUsername = await getMyDownline(UserID, token, Username)
    const getMyself = await getMyselfF(this.props.userID, token, Username)
    if(getMyself) {
      this.setState({ userID: getMyself[0].ID, SelectedUser: {value: getMyself[0].ID, label: getMyself[0].Username}, SearchUser: getMyself[0].Username }, () => {
        this.SelectedUser(this.state.SelectedUser)
      })
    }
  }

  async SelectedUser(e) {
    const GetUserDetails = await getUserKeyIn(e.value, this.props.token, this.props.username)
    // console.log('UserDetails', GetUserDetails);
    this.setState({ 
      userID: e.value,
      SelectedUser: e,
      Balance: GetUserDetails[0].CashWallet,
      SearchUser: e.label,
      KeyIn1: GetUserDetails[0].KeyIn1,
      KeyIn2: GetUserDetails[0].KeyIn2,
      FileResultWord: "",
      JinNan: GetUserDetails[0].JinNan,
      FileName: "",
    });

    this.handleCloseSearchModal();
  }

  async UploadFiletxt(event) {
    if (event !== undefined) {
      const files = event.target.files;
      event.preventDefault()
      const reader = new FileReader()
      reader.onload = async (e) => {
        const text = (e.target.result)
        this.setState({ FileResultWord: text })
        // this.setState({ FileResultWord: text }, ()=> {
        //   const Array = this.state.FileResultWord.split('\n')
        //   let Arraynew = []
        //   for(var i=0; i < Array.length; i++) {
        //     const RemoveR = Array[i].replace("\r", "").replace("\r", "")
        //     Arraynew.push(RemoveR)
        //   }
        //   this.setState({ FileResultWord: Arraynew.join('\n') })
        // })
      };
      if (event.target.files) {
        reader.readAsText(event.target.files[0])
        this.setState({ FileName: files[0].name })
      } 
    }
  }

  async recheckBet(UserID, UserOrderID) {
    rechecktimer = setInterval(async () => { 
      const recheckresult = await verifyUserOrderIDStatus(UserID, UserOrderID, this.props.token, this.props.username)
      if (recheckresult.message === 'Loading') {
        // this.openNotification('Success')
      } else {
        clearInterval(rechecktimer);
        this.openNotification('Success')
        this.setState({ loading: false })
      }
    }, 5000);
  }
  async ConfirmSaveBet() {
    this.setState({loading: true});
    const UserID = this.state.userID
    let originalText = this.state.FinalResult;
    const Array = this.state.FinalResult.split('\n')
    let Arraynew = []

    if(Array.length < 3 || Array[0] !== "D#"){
      this.openNotification('InvalidText');
      this.setState({ notificationType: 'error', loading: false });
      return;
    }

    for(var i=0; i < Array.length; i++) {
      const RemoveR = Array[i].replace("\r", "").replace("\r", "")
      Arraynew.push(RemoveR)
    }
    originalText = Arraynew.join('\n')

    this.setState({ disabled: true}, async()=>{
      if((originalText).length === 0){
        this.setState({ notificationType: 'error', loading: false }, ()=>{
          this.openNotification('Cannotemptytext')
        })
      } else if (/[a-zA-CE-Z!@$%^&()_‘+=\]{};':"\\|,<>?]+/.test(originalText)) {
        this.openNotification('FormatError')
        this.setState({ notificationType: 'error', loading: false });
      } else if (/[\u3400-\u9FBF]+/.test(originalText)) {
        this.openNotification('NotAllowChinese')
        this.setState({ notificationType: 'error', loading: false });
      } else {
        const OrderResult = await CreateBetOrder(UserID, originalText , this.props.token, this.props.username)
        if(OrderResult.error) {
          this.openNotification(ReturnBetValidation(OrderResult.error), (OrderResult.balance !== undefined) ? OrderResult.balance : '')
          this.setState({ notificationType: 'error', loading: false });
        } else {
          this.SelectedUser(this.state.SelectedUser)
          this.setState({ loading: OrderResult.finished ? false : true, ReceiptDisplay: OrderResult.receipt, ShowReceipt: true }, ()=> {
            this.ConvertResultRed(this.state.ReceiptDisplay)
            if (!OrderResult.finished) {
              this.recheckBet(OrderResult.UserID, OrderResult.UserOrderID)
            } else {
              this.openNotification('Success')
            }
          })
          this.CleanData()
        }
      }
    })
  }

  async ConvertResultRed(Receipt) {
    let Word = Receipt
    let returnWord = [];

    if (Word.includes('<red>')) {
      const WordArray = Word.split('<red>').join('</red>').split('</red>');
      for (let i = 0; i < WordArray.length; i += 1) {
        if (i === 0) {
          returnWord.push(<span key={i}>{WordArray[i]}</span>);
        } else if (i % 2 === 1) {
          returnWord.push(
            <span key={i} style={{color: 'red'}}>
              {WordArray[i]}
            </span>,
          );
        } else if (i % 2 === 0) {
          returnWord.push(<span key={i}>{WordArray[i]}</span>);
        }
      }
      this.setState({ReceiptDisplay: returnWord});
    } else {
      this.setState({ReceiptDisplay: Word});
    }
  }

  async CleanData() {
    this.setState({ FileName: '', FileResultWord: '', FinalResult: 'D#\n' }, () => {
      this.UploadFiletxt()
    })
  }

  onDragOver(evt) {
    evt.preventDefault();
    if (this.state.disabled) return;
  
    this.setState({ hightlight: true });
  }

  onDragLeave() {
    this.setState({ hightlight: false });
  }

  onDrop(event) {
    if (event !== undefined) {
      const files = event.dataTransfer.files;
      event.preventDefault()
      // console.log('selected user', this.state.SelectedUser);
      // console.log('keyin 1', this.state.KeyIn1);
      // console.log('keyin2', this.state.KeyIn2);

      const reader = new FileReader()
      reader.onload = async (e) => {
        const text = (e.target.result)
        this.setState({ FileResultWord: text })
      };
      if (event.dataTransfer.files) {
        reader.readAsText(event.dataTransfer.files[0])
        this.setState({ FileName: files[0].name,hightlight: false })
      }
    }
  }
  
  openFileDialog() {
    if (this.state.disabled) return
    this.fileInputRef.current.click()
  }

  openNotification(message, NotEnough) {
    this.setState({ notificationMessage: `${language[this.props.currentLanguage][message]} ${(NotEnough !== undefined && NotEnough !== '') ? `${language[this.props.currentLanguage].LeftCashWallet}:${NotEnough || ''}` : ``}` }, () => {
      this.setState({ showNotification: true });
    });
    clearTimeout(timer)
    timer = setTimeout(() => {
      this.setState({ 
        showNotification: false,
        notificationMessage: '',
        notificationType: 'success',
        disabled: false,
      });
    }, 5000);
  };

  ChangeReceipt(event) {
    const PressNumber = event.target.value.replace(/[+]/g, '#')
    this.setState({ FileResultWord: PressNumber })
  }

  // onDrop2 = (files) => {
  //   this.setState({files}, ()=> {
  //     if(this.state.files.length > 0) {
  //       this.getBase642(this.state.files[0])
  //     }
  //   })
  // }

  // getBase642(files){
  //   var reader = new FileReader();
  //   reader.readAsDataURL(files);
  //   reader.onload = () => {
  //     this.setState({ Base64: reader.result})
  //   };
  //   reader.onerror = function (error) {
  //   };
  // }

  // changeHandler = (event) => {
  //   this.getBase642(event.target.files[0])
  // }

  ShotCutKeySearchFunction(event){
    if (event.key === 'Enter') {
      this.SearchFunction();
    }
  }

  async SearchFunction(){
    this.setState({ SearchUSersModal: true })
    if (this.state.SearchUser !== '') {
      const Searchresult = await searchDownlineHR(this.state.SearchUser, this.props.Role, this.props.userID, this.props.token, this.props.username)
      if(Searchresult.message === 'Invalid Downline ID or Username') {
        this.setState({ notificationType: 'error' }, () => {
          this.openNotification('InvalidDownlineIDorUsername')
        });
      } else {
        Searchresult.sort((a, b) => (a.Role > b.Role) ? 1 : -1)
        this.setState({ SearchedID: Searchresult })
      }
    }
  }

  handleCloseSearchModal() {
    this.setState({
      SearchUSersModal: false,
      SearchedID : [],
    })
  }

  render() {
    return (
      <div className='StartBackground'>
        <Header />
        <SearchUsersModal SearchUSersModal={this.state.SearchUSersModal} SearchedID={this.state.SearchedID} SelectedUser={this.SelectedUser} handleCloseSearchModal={this.handleCloseSearchModal}/>
        <div className="dcc" style={{ justifyContent: 'center' }}>
          <Alert style={{ zIndex: 99, position: 'fixed', top: 100}}show={this.state.showNotification} variant={this.state.notificationType === 'error' ? 'danger' : 'success'}>
            <Alert.Heading>{this.state.notificationMessage}</Alert.Heading>
          </Alert>
        </div>
        <div className="row" style={{ marginBottom: 30, display: 'flex', marginLeft: 50, marginRight: 50, fontSize: '20px' }}>
          <div className="dcc jackpotborder" style={{ justifyContent: 'space-between', width: '100%'}}>
            <div style={{width: '33.3%'}}></div>
            <div style={{width: '33.3%'}} className='dcc'><FaHome size="25px" color="white" className="logohome" style={{ marginRight: 10 }} /> {`${language[this.props.currentLanguage].Betting} (${this.state.SelectedUser.label})`}</div>
            <div style={{ width: '33.3%', textAlign: 'right', paddingRight: 10, fontWeight: 'bold' }}>{`${language[this.props.currentLanguage].Balance} : $ ${this.state.Balance}`}</div>
          </div>
        </div>
        <div className="dcc mobileHeader"
          style={{
            marginTop: 20,
            paddingBottom: 0,
            justifyContent: 'space-between',
            marginLeft: '3.5%',
            flexDirection: 'row',
            width: '95%',
            marginBottom: 0,
          }}>
          <div className="TitleDate">{language[this.props.currentLanguage].Date}: {this.state.TodayDate}</div>
          {/* {isMobile && 
            <div className="TitleDate">{language[this.props.currentLanguage].Balance}: {`$ ${this.state.Balance}`}</div>
          } */}
          <div className="dcc" style={{ marginRight: 20 }}>
            <div className="TitleUsername"> ID - {this.state.username} </div>
          </div>
        </div>
        {/* <div className="dcc TextFontSize" style={{ marginBottom: 10 }}> 
          <div style={{ width: (isMobile) ? '80%' :'35%'}}>
            <Select
              isSearchable={this.state.optionsUsername.length === 0 ? false : true}
              options={this.state.optionsUsername}
              value={this.state.SelectedUser}
              onChange={(e) => this.SelectedUser(e)}
            >
            </Select>
          </div>
        </div> */}
        <div className='dcc' style={{ display: 'flex', alignItems: 'center', marginBottom: 10, flexDirection: 'row' }}>
          <div style={{ margin: '0px 10px',  fontWeight: 'bold'}}>{language[this.props.currentLanguage].SearchAccount}</div>
          <Form.Control style={{ width: 200, marginRight: 10, fontWeight: 'bold'}} type="text" placeholder="ID / Username" value={this.state.SearchUser} onChange={(e) => this.setState({SearchUser: e.target.value})} onKeyPress={(e) => this.ShotCutKeySearchFunction(e)}/>
          <Button  className='button2' variant="primary" onClick={() => this.SearchFunction()}>{language[this.props.currentLanguage].Search}</Button>
          <Button  className='button2' variant="primary" style={{ marginLeft: 5 }} onClick={() => this.getDownline()}>{'Self'}</Button>
        </div>
        <div className="dcc" style={{ flexDirection: 'row' }}>
          {this.state.loading ? (
            <div style={{ flexDirection: 'column', width: '100%' }}>
              <div>
                <img src={Loading3} alt="Logo" className="loadingimages" style={{ marginBottom: 30, marginTop: 50 }} />
                <div className="loadingMessage">{language[this.props.currentLanguage].LoadingPleaseWaitAMoment}</div>
              </div>
            </div>
          ) : (
            <div style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
              <div style={{ backgroundColor: '#EFEFEF', border: `1px solid #d8d8d8`, width: '65%', marginBottom: 50 }}>
                <div className="dcc" style={{ width: '100%', marginBottom: 20, marginTop: 15 }}>
                  <div
                    className="form-control"
                    style={{ textAlign: 'center', width: '65%', height: 350, fontWeight: 'bold', overflowY: 'scroll', whiteSpace: 'pre'}}
                    value={this.state.FileResultWord}
                    readOnly={true}
                    onChange={(e) => this.ChangeReceipt(e)}
                  >
                    {this.state.FileResultWord}
                  </div>
                  <div
                    className="form-control"
                    style={{ textAlign: 'center', width: '35%', height: 350, fontWeight: 'bold', overflowY: 'scroll', whiteSpace: 'pre'}}
                    value={this.state.FileResultWord}
                    readOnly={false}
                    onChange={(e) => this.ChangeReceipt(e)}
                  >
                    {this.state.FinalResult}
                  </div>
                </div>
                <div style={{ marginBottom: 10, fontWeight: 'bold', fontSize:18}}>{language[this.props.currentLanguage].CurrentFormat} : {this.state.KeyIn1.join(', ')}</div>
                <div style={{ marginBottom: 20, fontWeight: 'bold', fontSize:18}}>{language[this.props.currentLanguage].CurrentFormat} ** : {this.state.KeyIn2.join(', ')}</div>
                <div 
                  // type='file'
                  className={`Dropzone ${this.state.hightlight ? "Highlight" : ""}`}
                  onDragOver={this.onDragOver}
                  onDragLeave={this.onDragLeave}
                  onDrop={this.onDrop}
                  onClick={this.openFileDialog}
                  style={{ cursor: this.state.disabled ? "default" : "pointer" }}
                >
                  <span>Upload Files</span>
                </div>
                <input
                  key={this.state.FileName}
                  onChange={(event) => {
                    this.UploadFiletxt(event)
                  }}
                  onClick={(event) => event.target.value = ''}
                  multiple={false}
                  ref={this.fileInputRef}
                  type='file'
                  hidden
                />
                <div style={{ marginBottom: 20, fontWeight: 'bold' }}>{language[this.props.currentLanguage].FileName} : {this.state.FileName || ''}</div>

                <div style={{ width: '100%', paddingBottom: 40 }}>
                  <button style={{ textAlign: 'center', backgroundColor: '#EE3E13', color: 'white', width: 200, fontWeight: 'bold', marginRight: 20 }}
                    disabled={this.state.disabled}
                    onClick={() => this.CleanData()}
                    className="btn my-cusomized-button button2 MenubarTitle">
                    {language[this.props.currentLanguage].ClearAll}
                  </button>
                  <button style={{ textAlign: 'center', backgroundColor: '#3C96F4', color: 'white', width: 200, fontWeight: 'bold' }}
                    disabled={this.state.disabled}
                    onClick={() => this.ConfirmSaveBet()}
                    className="btn my-cusomized-button button2 MenubarTitle">
                    {language[this.props.currentLanguage].ConfirmTicket}
                  </button>
                </div>
              </div>
              {/* <div>
                <Dropzone onDrop={this.onDrop2}>
                  {({getRootProps, getInputProps}) => (
                    <section className="container">
                      <div {...getRootProps({className: 'dropzone'})}>
                        <input {...getInputProps()} />
                        <p>Drag 'n' drop some files here, or click to select files</p>
                      </div>
                      <aside>
                        <h4>Files</h4>
                        <ul>{files}</ul>
                      </aside>
                    </section>
                  )}
                </Dropzone>
              </div>
              <input type="file" name="file" onChange={this.changeHandler} /> */}
              {this.state.ShowReceipt === true && 
              <div className="column" style={{ backgroundColor: 'white', width: '20%', borderColor: 'black', borderRadius: 5, marginLeft: 10, maxHeight: "500px", overflowY:"scroll" }}>
                <div className="dcc row" style={{ marginBottom: 30, fontWeight: 'bold', fontSize: '20px', position: 'sticky', top:0 }}>
                  <div>{`${(this.state.SuccessFullCancel === true) ? 
                    language[this.props.currentLanguage].CancelSuccessfulldisplay
                    : language[this.props.currentLanguage].SuccessOrderBet }`}</div>
                  <div>
                    <GrFormClose
                      style={{ cursor: 'pointer'}}
                      onClick={() => {
                        this.setState({ ShowReceipt: false, ReceiptDisplay: '' })
                      }}
                      size="35px"
                      color="#000"
                    />
                  </div>
                </div>
                <div className="column" style={{ marginBottom: 30, fontSize: '16px', whiteSpace: 'pre-wrap', fontWeight: 'bold', textAlign: 'start', marginLeft: 10 }}>
                  {this.state.ReceiptDisplay}
                </div>
                {/* <button style={{ backgroundColor: '#3C96F4', color: 'white', width: 'auto', fontWeight: 'bold', marginBottom: 30 }}
                  onClick={() => this.CancelBetAPI()}
                  className="btn my-cusomized-button" >
                  {language[this.props.currentLanguage].CancelTicket}
                </button> */}
              </div>
              }
            </div>
          )}
          {/* <div>
          <div 
            type='file'
           className={`Dropzone ${this.state.hightlight ? "Highlight" : ""}`}
           onDragOver={this.onDragOver}
           onDragLeave={this.onDragLeave}
           onDrop={this.onDrop}
           onClick={this.openFileDialog}
           style={{ cursor: this.state.disabled ? "default" : "pointer" }}
           >
          <span>Upload Files</span>
          </div>
            <button
              onClick={() => this.fileInputRef.current.click()}
              style={{ textAlign: 'center', backgroundColor: '#3C96F4', color: 'white', width: '95%', fontWeight: 'bold', height: 50 }}
            >
              {'UPLOAD FILE'}
            </button>
            <input
              key={this.state.FileName}
              onChange={(event) => {
                this.UploadFiletxt(event)
              }}
              multiple={false}
              ref={this.fileInputRef}
              type='file'
              hidden
            />
          </div> */}
        
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    userID: state.userID,
    username: state.username,
    token: state.token,
    Role: state.Role,
    hide: state.hide,
    currentLanguage: state.currentLanguage,
    UserAuthority: state.UserAuthority,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    setLoginStatus: (Username, UserToken, Role) => {
      dispatch({
        type: 'LOGIN_STATUS',
        payload: {
          username: Username,
          token: UserToken,
          Role: Role,
        },
      });
    },
    setLanguage: (lg) => {
      dispatch({ type: 'SET_LANGUAGE', payload: lg });
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CSVFileConvert);
